import type { UserRole } from '@/types'

export const isSuperAdmin = (role?: UserRole): boolean => role === 'super_admin'
export const isAdmin = (role?: UserRole): boolean =>
  role === 'super_admin' || role === 'tenant_admin'
